<template>
<div class="screen-layout">
    <div class="no-print">
        <slot name="header">
            <v-toolbar flat dark dense class="primary" xxstyle="z-index:8;position:fixed;">
                    
                <v-btn @click.native="$router.push('/home')" icon>
                    <v-icon>chevron_left</v-icon>
                </v-btn>        
                <v-toolbar-title>{{title}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <!-- <v-btn icon>
                    <v-icon>search</v-icon>
                </v-btn> -->
                <v-btn @click="rightColumnActive = !rightColumnActive" icon>
                    <!-- <v-icon>more_vert</v-icon> -->
                </v-btn>
            </v-toolbar>
        </slot>
    </div>

    <div class="page-area" style="overflow:hidden" >

        <div v-if="leftVisible" class="column left-column no-print" :class="{'active': leftColumnActive, 'wider': leftWider, 'uniform': uniformColour}">
            <slot name="left">
                Left slot <span v-for="n in 20">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Optio repellat, doloremque, delectus dolores veritatis iste excepturi quasi voluptate aspernatur sed doloribus aliquam sit unde dolor velit saepe aperiam? Consequatur, veritatis!</span> End left slot
            </slot>
        </div>

        <div ref="middleColumn" id="middle-column" class="column middle-column">
            <slot>
                Default slot <span v-for="n in 30">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Optio repellat, doloremque, delectus dolores veritatis iste excepturi quasi voluptate aspernatur sed doloribus aliquam sit unde dolor velit saepe aperiam? Consequatur, veritatis!</span> End default slot                
            </slot>  
        </div>

        <div v-if="rightVisible" class="column right-column no-print" :class="{'active': rightColumnActive, 'uniform': uniformColour}">
            <slot name="right">
                Right slot <span v-for="n in 20">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Optio repellat, doloremque, delectus dolores veritatis iste excepturi quasi voluptate aspernatur sed doloribus aliquam sit unde dolor velit saepe aperiam? Consequatur, veritatis!</span> End right slot
            </slot>              
        </div>

        <!-- Expander Buttons -->


        <div @click="expandLeft" v-if="leftButtonVisible" class="expander left-expander clickable no-print" :class="{'active': leftColumnActive}">
            <v-icon color="white">keyboard_arrow_right</v-icon>
        </div>
        <div v-if="rightButtonVisible" @click="expandRight" class="expander clickable right-expander no-print" :class="{'active': rightColumnActive}">
            <v-icon color="white">keyboard_arrow_left</v-icon>
        </div>        
        <div class="overlay left-overlay" v-if="leftColumnActive" @click="overlayClicked"></div>
        <div class="overlay right-overlay" v-if="rightColumnActive" @click="overlayClicked"></div>

    </div>


</div>
</template>

<script>

import ScrollHelpers from '../helpers/ScrollHelpers'

export default {
    data() {
        return {
            leftColumnActive: false,
            rightColumnActive: false,
        }
    },

    components: {

    },
    
    props: {
        leftVisible: {
            default: true,
            type: Boolean,
        },
        leftWider: {
            default: false,
            type: Boolean,
        },
        rightVisible: {
            default: true,
            type: Boolean,
        },
        title: {
            default: 'Taco',
            type: String,
        },
        uniformColour: {
            type: Boolean,
        }
        
    },

    computed: {
        leftButtonVisible() {
            return this.leftVisible && !this.leftColumnActive
        },
        rightButtonVisible() {
            return this.rightVisible && !this.rightColumnActive
        },

    },

    methods: {
        overlayClicked() {
            this.leftColumnActive = false
            this.rightColumnActive = false
        },
        expandLeft() {
            this.leftColumnActive = !this.leftColumnActive
            this.rightColumnActive = false
        },
        expandRight() {
            this.rightColumnActive = !this.rightColumnActive
            this.leftColumnActive = false
        },
    },


}
</script>

<style scoped>
.screen-layout {
    height:100%;position:relative;display:flex;flex-direction:column;overflow:hidden;
}

.page-area {
    display:flex;
    flex-grow:1;
    flex-shrink:1;
    position:relative;
}
.column {
    box-sizing: border-box;
    scroll-behavior: smooth;
    overflow-y:auto;
    transition: all .3s ease-in-out;
    -webkit-overflow-scrolling: touch;
    /* margin-bottom: 5px; */
}

.overlay {
    z-index: 4;
    position:fixed;
    top:0; left:0; right:0; bottom:0;
    background-color: rgba(0,0,0,0.5);
    visibility:hidden;
}

.left-column {
    flex:0 0 200px;
    background-color: #f0f0f0;
    /* background-color: white; */
    -webkit-overflow-scrolling: touch;
    z-index: 5;
    border-right:solid 3px #ddd;
}
.left-column.wider {
    flex:0 0 250px;
}

.middle-column {
    flex: 1 1 auto;
    background-color: #ddd;
    overflow-y:auto;
}
.right-column {
    flex:0 0 300px;
    background-color:#ccc;
    z-index: 5;
}

.right-column.uniform {
    background-color: #ddd;
}

.left-column.uniform {
    background-color: #ddd;
}

.expander{
    padding-top:12px;
    background-color: rgba(0,0,0,0.5);
    border-radius:10px;
    position:fixed;top:50%;height:50px;width:50px;display:none;   
    transition: transform 1s ease-in-out; 
}

.right-expander {
    right:-25px;
}

.left-expander {
    left:-25px;
    text-align:right;
}

.expander.active .v-btn {
    transform: rotate(180deg);
}

@media (min-width:1200px) {
    .right-column {
        flex: 0 0 400px;
    } 
   
}

@media (min-width:900px) {
    .left-column {
        flex: 0 0 250px;
    } 
    .left-column.wider {
        flex: 0 0 300px;
    }
}

@media (min-width:1400px) {
    .right-column {
        flex:0 0 450px;   
    } 
}
@media (min-width:1600px) {
    .right-column {
        flex:0 0 550px;   
    } 
}
@media (min-width:1800px) {
    .right-column {
        flex:0 0 700px;   
    } 
}
@media (min-width:2000px) {
    .right-column {
        flex:0 0 900px;   
    } 
}

@media (max-width:1000px) {
    .right-column {
        position:absolute;
        top:0px; bottom:0px; right: -300px;width:300px;
        /* border-style:dashed; */
        opacity:0;
        
    } 
    .right-column.active {
        right:0;
        opacity: 1;
    }
    .right-expander {
        display:block;
        z-index:10;
    }
    .right-overlay {
        visibility: visible;
    }
}
@media (max-width:600px) {
    .left-column {
        position:absolute;
        top:0px; bottom:0px; left: -250px; width:250px;
        opacity: 0;
    }
    .left-column.wider {
        left: -300px; width: 300px;
    }

    .left-column.active {
        left:0;
        opacity:1;
    }

    .left-expander {
        display:block;
        z-index: 10;
    }
    .left-overlay {
        visibility: visible;
    }

}
   
</style>




// WEBPACK FOOTER //
// ScreenLayout.vue?30b4acde